import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-check\"><defs><style type=\"text/css\">@font-face { font-family: element-icons; src: url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.woff\") format(\"woff\"), url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.ttf \") format(\"truetype\"); }\n</style></defs><path d=\"M512 853.333333c188.522667 0 341.333333-152.810667 341.333333-341.333333S700.522667 170.666667 512 170.666667 170.666667 323.477333 170.666667 512s152.810667 341.333333 341.333333 341.333333z m0 42.666667c-212.074667 0-384-171.925333-384-384S299.925333 128 512 128s384 171.925333 384 384-171.925333 384-384 384z\" p-id=\"9954\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/m-common/svg/md-icon/check.svg
// module id = DPYG
// module chunks = 317